import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  SEGMENTS_LIST,
  SEGMENTS_NEW,
  SEGMENTS_EDIT,
  SEGMENTS_DELETE
} from "./actionTypes"

import {
  segmentsListSuccess,
  segmentsListError,
  segmentsNewSuccess,
  segmentsNewError,
  segmentsDeleteSuccess,
  segmentsDeleteError
} from "./actions"

import {
  apiGetSegmentsList,
  apiPostSegmentsNew,
  apiPatchSegmentsEdit,
  apiDeleteSegmentsDelete,
} from "../../api/calls/segments"

function* segmentsList({payload: data}) {
  try {
    const response = yield call(apiGetSegmentsList, data)
    yield put(segmentsListSuccess(response))
  } catch (error) {
    yield put(segmentsListError(error))
  }
}

function* segmentsNew({payload: data}) {
  try {
    const response = yield call(apiPostSegmentsNew, data)
    yield put(segmentsNewSuccess(response))
  } catch (error) {
    yield put(segmentsNewError(error))
  }
}

function* segmentsEdit({payload: data}) {
  try {
    const response = yield call(apiPatchSegmentsEdit, data)
    yield put(segmentsNewSuccess(response))
  } catch (error) {
    yield put(segmentsNewError(error))
  }
}

function* segmentsDelete({payload: data}) {
  try {
    const response = yield call(apiDeleteSegmentsDelete, data)
    yield put(segmentsDeleteSuccess(response))
  } catch (error) {
    yield put(segmentsDeleteError(error))
  }
}

export function* watchSegmentsList() {
  yield takeEvery(SEGMENTS_LIST, segmentsList);
}

export function* watchSegmentsNew() {
  yield takeEvery(SEGMENTS_NEW, segmentsNew);
}

export function* watchSegmentsEdit() {
  yield takeEvery(SEGMENTS_EDIT, segmentsEdit);
}

export function* watchSegmentsDelete() {
  yield takeEvery(SEGMENTS_DELETE, segmentsDelete);
}

function* segmentsSaga() {
  yield all([
    fork(watchSegmentsList),
    fork(watchSegmentsNew),
    fork(watchSegmentsEdit),
    fork(watchSegmentsDelete),
  ]);
}

export default segmentsSaga
